/* Aura Noire · selector de formato (2 / 5 / 10 ml) + botón de carrito de las tarjetas de colección.
   - Pulsar un tamaño SOLO cambia la selección: actualiza el id de variante del formulario y el precio visible.
   - El botón de carrito (submit real del <product-form> del tema) es lo único que añade al carrito, así que el
     drawer / notificación / contador usan exactamente el mismo código que el resto de la tienda.
   Los ids de variante y los precios los genera card-product.liquid con las variantes reales del producto. */
if (!customElements.get('aura-ml-picker')) {
  customElements.define(
    'aura-ml-picker',
    class AuraMlPicker extends HTMLElement {
      connectedCallback() {
        this.idInput = this.querySelector('[name="id"]');
        this.cart = this.querySelector('.aura-ml__cart');
        this.sizes = Array.from(this.querySelectorAll('.aura-ml__btn'));
        this.priceEl = this.closest('.card-wrapper')?.querySelector('[data-aura-price-text]') || null;
        if (!this.idInput || !this.cart || !this.sizes.length) return;

        this.sizes.forEach((btn) => {
          btn.addEventListener('click', () => this.select(btn));
          btn.addEventListener('keydown', (e) => this.onKey(e, btn));
        });

        // product-form pone/quita la clase "loading" en el botón de envío durante /cart/add.
        this.observer = new MutationObserver(() => this.onCartState());
        this.observer.observe(this.cart, { attributes: true, attributeFilter: ['class'] });
        this.wasLoading = false;
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        clearTimeout(this.addedTimer);
      }

      select(btn) {
        if (btn.disabled) return;
        this.sizes.forEach((b) => b.setAttribute('aria-checked', b === btn ? 'true' : 'false'));
        this.idInput.value = btn.dataset.variantId;
        this.cart.disabled = false;
        if (this.priceEl && btn.dataset.price) this.priceEl.textContent = btn.dataset.price;
      }

      onKey(e, btn) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        const enabled = this.sizes.filter((b) => !b.disabled);
        const i = enabled.indexOf(btn);
        if (i < 0) return;
        const next = enabled[(i + (e.key === 'ArrowRight' ? 1 : enabled.length - 1)) % enabled.length];
        e.preventDefault();
        this.select(next);
        next.focus();
      }

      onCartState() {
        const loading = this.cart.classList.contains('loading');
        if (this.wasLoading && !loading) {
          const err = this.querySelector('.aura-ml__error');
          if (err && err.hasAttribute('hidden')) {
            this.classList.add('is-added');
            clearTimeout(this.addedTimer);
            this.addedTimer = setTimeout(() => this.classList.remove('is-added'), 1400);
          }
        }
        this.wasLoading = loading;
      }
    }
  );
}
